// extracted by mini-css-extract-plugin
export default {"action-wrapper":"PersonnelTable_action-wrapper__f9Hfv"};